/* eslint-disable react/react-in-jsx-scope */
import React, { useState, useEffect } from 'react';
import makeAnimated from 'react-select/animated';

import { Chip } from '@material-ui/core';
import Select from 'react-select';
import { MdAccessAlarms } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Col, Input, Row } from 'reactstrap';
import { ChipTime, ContentCheckbox } from '../style';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import QueueService from '../../../../Queue/service';
import { Form } from '../../channels/modals/facebook/style';
import { ButtonChat } from 'views/ChatConfiguration/components/buttons';
import { toast } from 'react-toastify';
import FlexChatIntegrationService from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration/index';
import NewService from '../../../service/newService';
import getFlexIAType from 'views/FlexIA/utils/getFlexIAType';
import { getActionOptions } from './utils/getActionOptions';
import FlexSelect from 'components/Inputs/FlexSelect';
import { handleFilterFlexiaByType } from 'utils/fuctions/handleFilterFlexiaByType';

const ModalCreate = ({
  info,
  modifyStateModal,
  setTimeoutConfigs,
  flexias
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const dados = useSelector((state) => state.createObject.data);
  const [initialState, setInitialState] = useState(info);
  const [queues, setQueues] = useState([]);
  const [channels, setChannels] = useState([]);
  const [activeReminderMessage, setActiveReminderMessage] = useState(false);
  const [activeSurveyOnTimeout, setActiveSurveyOnTimeout] = useState(false);
  const animatedComponents = makeAnimated();

  useEffect(() => {
    QueueService.getAll()
      .then((response) => {
        const newQueues = response.data.data.map((queue) => ({
          label: queue.name,
          value: queue.id
        }));
        setQueues(newQueues);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });

    FlexChatIntegrationService.getAllChannels()
      .then((result) => {
        const dataChannels = [];
        const dataResponse = result.data.data;

        Object.keys(dataResponse).forEach((channelName) => {
          const channelData = dataResponse[channelName];
          if (Array.isArray(channelData)) {
            channelData.forEach((channel) => {
              if (channel.id) {
                dataChannels.push({
                  label: channel.nome_canal,
                  value: channel.id
                });
              }
            });
          } else {
            if (channelData.id) {
              dataChannels.push({
                label: channelData.nome_canal,
                value: channelData.id
              });
            }
          }
        });

        setChannels(dataChannels);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    setInitialState(info);
    setActiveReminderMessage(info?.activeReminderMessage ?? false);
    setActiveSurveyOnTimeout(info?.sendSurveyOnTimeout ?? true);
  }, [info, dados]);

  function setStateModal(event) {
    event.preventDefault();
    modifyStateModal(false);
  }

  function controlToggleActive(control) {
    setInitialState({ ...initialState, ignoreWeekend: control });
  }

  function controlToggleSurveyActive(control) {
    setActiveSurveyOnTimeout(control);
  }

  function controlToggleActiveReminder(control) {
    setActiveReminderMessage(control);
  }

  function sendObject(event) {
    event.preventDefault();

    switch (initialState.typeOfAttendant) {
      case 'Atendente':
        initialState.inTheFlexIAs = [];
        break;
      case 'FlexIA':
        initialState.inTheQueues = [];
        break;
    }

    initialState.activeReminderMessage = activeReminderMessage;
    initialState.sendSurveyOnTimeout = activeSurveyOnTimeout;

    NewService.createTimeout(initialState)
      .then((response) => {
        setStateModal(event);
        if (response.data) {
          setTimeoutConfigs(response.data.data);
          toast.success('Timeout criado com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.message || 'Ops, ocorreu um erro', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
  }

  function setDataModal(event, option, name) {
    if (name === 'inTheQueues') {
      const labels = event ? event.map((option) => option.label) : [];
      setInitialState({
        ...initialState,
        inTheQueues: labels
      });
    } else if (name === 'inTheFlexIAs') {
      const values = event ? event.map((option) => option.value) : [];
      setInitialState({
        ...initialState,
        inTheFlexIAs: values
      });
    } else if (event?.target?.name === 'typeOfAttendant') {
      setInitialState({
        ...initialState,
        action: 'encerrar',
        [event.target.name]: event.target.value
      });
    } else if (name === 'channels') {
      const labels = event ? event.map((option) => option.label) : [];
      setInitialState({
        ...initialState,
        channels: labels
      });
    } else if (event?.target?.name === 'ignoraFinalDeSemana') {
      setInitialState({
        ...initialState,
        [event.target.name]: event.target.checked
      });
    } else if (
      ['timeoutReminder', 'timeoutClosing'].includes(event?.target?.name)
    ) {
      const value = parseInt(event.target.value);
      setInitialState({
        ...initialState,
        [event.target.name]: value
      });
    } else {
      setInitialState({
        ...initialState,
        [event.target.name]: event.target.value
      });
    }
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 46,
      color: '#8898aa',
      backgroundColor: '#fff',
      border: '1px solid #dee2e6'
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: '#8898aa',
      fontSize: '0.875rem'
    })
  };

  function getTimeoutOriginField() {
    switch (initialState.typeOfAttendant) {
      case 'Atendente':
        return (
          <Col md="8">
            <label>Fila(s) de Origem</label>
            <Select
              placeholder="Selecione ..."
              components={animatedComponents}
              styles={customStyles}
              options={queues.map((option) => ({
                label: option.label,
                value: option.label
              }))}
              isMulti
              name="inTheQueues"
              id="inTheQueues"
              key="inTheQueues"
              onChange={(event, option) =>
                setDataModal(event, option, 'inTheQueues')
              }
              defaultValue={initialState?.inTheQueues?.map((value) => ({
                label: value,
                value
              }))}
              isClearable
              isSearchable
              isLoading={false}
              isRtl={false}
              closeMenuOnSelect={false}
            />
          </Col>
        );
      case 'FlexIA':
        return (
          <Col md="8">
            <label>FlexIAs</label>
            <FlexSelect
              dataOptions={handleFilterFlexiaByType(flexias) ?? []}
              labelName="label"
              valueName="value"
              placeholder="Selecione ..."
              fieldName="inTheFlexIAs"
              isMulti={true}
              value={initialState?.inTheFlexIAs || []}
              valueController={(fieldName, value) =>
                setDataModal(
                  value.map((v) => ({ value: v })),
                  { name: fieldName },
                  fieldName
                )
              }
              closeMenuOnSelect={false}
              isClearable={true}
              isSearchable={true}
              isDisabled={false}
              noOptionsMessage={() => 'Nenhuma Opção'}
              formatOptionLabel={(option) =>
                `${option.label} - ${getFlexIAType(
                  flexias.find((f) => f.id === option.value)?.type || ''
                )}`
              }
            />
          </Col>
        );
    }
  }

  return (
    <>
      <Form>
        <Row className="row">
          <Col md="4">
            <label>Regra:</label>
            <Input
              onChange={setDataModal}
              type="select"
              name="typeOfAttendant"
              value={initialState.typeOfAttendant}
            >
              <option value="Atendente">Atendente</option>
              <option value="FlexIA">FlexIA</option>
            </Input>
          </Col>
          <Col md="4">
            <label>Canais: </label>
            <Select
              placeholder="Selecione um canal..."
              components={animatedComponents}
              styles={customStyles}
              options={channels?.map((option) => ({
                label: option?.label,
                value: option?.label
              }))}
              isMulti
              name="channels"
              onChange={(event, option) =>
                setDataModal(event, option, 'channels')
              }
              defaultValue={initialState?.channels?.map((value) => ({
                label: value,
                value
              }))}
              isClearable
              isSearchable
              isLoading={false}
              isRtl={false}
              closeMenuOnSelect={false}
            />
          </Col>
        </Row>

        <Row>
          {getTimeoutOriginField()}
          {getActionOptions(
            flexias,
            initialState.typeOfAttendant,
            initialState.inTheFlexIAs,
            initialState.action,
            setDataModal
          )}

          {initialState.action === 'transferir' && (
            <Col md="2">
              <label>Transferir para:</label>
              <Input
                type="select"
                onChange={setDataModal}
                name="transferQueue"
                value={initialState.transferQueue}
              >
                <option value="">Selecione uma transferência</option>
                {queues &&
                  queues.map((queue) => (
                    <option key={queue.value} value={queue.label}>
                      {queue.label}
                    </option>
                  ))}
              </Input>
            </Col>
          )}
        </Row>
        <Row
          style={{
            marginTop: '20px',
            display: activeReminderMessage ? 'flex' : 'none'
          }}
        >
          <div
            style={{
              background: '#e9ecef',
              width: '100%',
              height: '1px',
              margin: '20px'
            }}
          />
          <Col
            md="9"
            style={{
              marginBottom: '20px'
            }}
          >
            <label>{`Mensagem do Lembrete de ${
              initialState.action === 'encerrar'
                ? 'Encerramento'
                : 'Transferência'
            }:`}</label>
            <Input
              type="textarea"
              onChange={setDataModal}
              value={initialState.reminderMessage}
              defaultValue={initialState.reminderMessage}
              name="reminderMessage"
            />
          </Col>
          {initialState.typeOfAttendant === 'Chatbot' ? (
            <ChipTime>
              <Col>
                <Chip
                  avatar={<MdAccessAlarms color="white" />}
                  size="small"
                  className="chipTime"
                  label="TEMPO EM MINUTOS"
                />
                <Input
                  defaultValue={initialState.timeoutReminder}
                  type="number"
                  name="timeoutReminder"
                  min={1}
                  max={1440}
                  value={initialState.timeoutReminder}
                  onChange={(e) => {
                    setDataModal(e, null, 'timeoutReminder');
                  }}
                />
              </Col>
            </ChipTime>
          ) : (
            <ChipTime>
              <Col>
                <Chip
                  avatar={<MdAccessAlarms color="white" />}
                  size="small"
                  className="chipTime"
                  label="TEMPO EM MINUTOS"
                />
                <Input
                  defaultValue={initialState.timeoutReminder}
                  type="number"
                  name="timeoutReminder"
                  min={1}
                  max={1440}
                  value={initialState.timeoutReminder}
                  onChange={(e) => {
                    setDataModal(e, null, 'timeoutReminder');
                  }}
                />
              </Col>
            </ChipTime>
          )}
        </Row>
        <Row
          style={{
            marginTop: '20px',
            marginBottom: '20px'
          }}
        >
          <div
            style={{
              background: '#e9ecef',
              width: '100%',
              height: '1px',
              margin: '20px'
            }}
          />
          <Col
            md="9"
            style={{
              marginBottom: '20px'
            }}
          >
            <label>{`Mensagem de ${
              initialState.action === 'encerrar'
                ? 'Encerramento'
                : 'Transferência'
            }:`}</label>

            <Input
              type="textarea"
              onChange={setDataModal}
              defaultValue={initialState.closingMessage}
              name="closingMessage"
            />
          </Col>
          {initialState.typeOfAttendant === 'Chatbot' ? (
            <ChipTime>
              <Col>
                <Chip
                  avatar={<MdAccessAlarms color="white" />}
                  size="small"
                  className="chipTime"
                  label="TEMPO EM MINUTOS"
                />
                <Input
                  defaultValue={initialState.timeoutClosing}
                  type="number"
                  name="timeoutClosing"
                  min={1}
                  onChange={setDataModal}
                />
              </Col>
            </ChipTime>
          ) : (
            <ChipTime>
              <Col>
                <Chip
                  avatar={<MdAccessAlarms color="white" />}
                  size="small"
                  className="chipTime"
                  label="TEMPO EM MINUTOS"
                />
                <Input
                  defaultValue={initialState.timeoutClosing}
                  type="number"
                  name="timeoutClosing"
                  min={1}
                  onChange={setDataModal}
                />
              </Col>
            </ChipTime>
          )}
        </Row>

        <Row>
          <ContentCheckbox color={systemConfiguration.primary_color}>
            <Col>
              <label
                className="titleMsg"
                style={{
                  fontWeight: 'bold'
                }}
              >
                Ignorar final de semana
              </label>
              {initialState.ignoreWeekend === true ? (
                <Chip size="small" className="chipTrue" label="HABILITADO" />
              ) : (
                <Chip size="small" className="chipFalse" label="DESABILITADO" />
              )}
            </Col>

            <ToggleSwitch
              checked={initialState.ignoreWeekend}
              id={'ativado'}
              onChange={() => controlToggleActive(!initialState.ignoreWeekend)}
            />
          </ContentCheckbox>

          <ContentCheckbox color={systemConfiguration.primary_color}>
            <Col>
              <label
                className="titleMsg"
                style={{
                  fontWeight: 'bold'
                }}
              >{`Ativar Lembrete de ${
                initialState.action === 'encerrar'
                  ? 'Encerramento'
                  : 'Transferência'
              }`}</label>
              {activeReminderMessage ? (
                <Chip size="small" className="chipTrue" label="HABILITADO" />
              ) : (
                <Chip size="small" className="chipFalse" label="DESABILITADO" />
              )}
            </Col>
            <ToggleSwitch
              checked={activeReminderMessage}
              id={'activeReminderMessage'}
              onChange={() =>
                controlToggleActiveReminder(!activeReminderMessage)
              }
            />
          </ContentCheckbox>
          <ContentCheckbox color={systemConfiguration.primary_color}>
            <Col>
              <label
                className="titleMsg"
                style={{
                  fontWeight: 'bold'
                }}
              >
                Enviar Pesquisa de Satisfação
              </label>
              {activeSurveyOnTimeout === true ? (
                <Chip size="small" className="chipTrue" label="HABILITADO" />
              ) : (
                <Chip size="small" className="chipFalse" label="DESABILITADO" />
              )}
            </Col>

            <ToggleSwitch
              checked={activeSurveyOnTimeout}
              id={'sendSurveyOnTimeout'}
              onChange={() => controlToggleSurveyActive(!activeSurveyOnTimeout)}
            />
          </ContentCheckbox>
        </Row>
        <Row className="row">
          <Col md="12" className="button">
            <ButtonChat
              action={(event) => sendObject(event)}
              name={'Salvar'}
              color={systemConfiguration.confirmation_button_color}
            />
            <ButtonChat
              action={(event) => setStateModal(event)}
              name={'Fechar'}
              color={systemConfiguration.cancelation_button_color}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export { ModalCreate };
